<div class="erv" *ngIf="verified; else gateTpl">

  <header class="erv-head">
    <div>
      <div class="erv-eyebrow ei-mono">Editorial Article Review</div>
      <h1 class="erv-title">Review queue</h1>
    </div>
    <span class="erv-pill info ei-mono">Dev2 · review only · publish OFF</span>
  </header>

  <div class="erv-body">

    <!-- ============ QUEUE ============ -->
    <aside class="erv-queue">
      <div class="erv-filters ei-mono">
        <button *ngFor="let f of filters" class="erv-fbtn"
                [class.on]="statusFilter === f.key" (click)="setFilter(f.key)">{{ f.label }}</button>
      </div>
      <div class="erv-qlist">
        <div class="erv-empty ei-mono" *ngIf="loadingQueue">Loading queue…</div>
        <div class="erv-empty ei-mono" *ngIf="!loadingQueue && !articles.length">No articles for this filter.</div>
        <button *ngFor="let a of articles" class="erv-qitem"
                [class.on]="selected?.id === a.id" (click)="select(a)">
          <div class="erv-qtop">
            <span class="erv-qreg special-title">{{ a.formatted_registration || a.registration }}</span>
            <span class="erv-pill ei-mono" [ngClass]="statusClass(a.status)">{{ statusLabel(a.status) }}</span>
          </div>
          <div class="erv-qhead">{{ a.headline || '(no headline yet)' }}</div>
          <div class="erv-qmeta ei-mono">conf {{ a.confidence ?? '—' }} · {{ a.updated_at | date:'d MMM HH:mm' }}</div>
        </button>
      </div>
    </aside>

    <!-- ============ DETAIL ============ -->
    <section class="erv-detail">
      <div class="erv-empty ei-mono" *ngIf="!selected">Select an article from the queue to review it.</div>

      <ng-container *ngIf="selected as s">
        <!-- action bar -->
        <div class="erv-actionbar">
          <div class="erv-abmeta">
            <span class="erv-abreg special-title">{{ s.formatted_registration || s.registration }}</span>
            <span class="erv-pill ei-mono" [ngClass]="statusClass(s.status)">{{ statusLabel(s.status) }}</span>
          </div>
          <div class="erv-abbtns ei-mono">
            <button class="erv-btn ok" [disabled]="acting" (click)="approve()">Approve</button>
            <button class="erv-btn bad" [disabled]="acting" (click)="reject()">Reject</button>
            <button class="erv-btn warn" [disabled]="acting" (click)="requestChanges()">Request changes</button>
            <button class="erv-btn" [disabled]="regenerating" (click)="regenerate()">{{ regenerating ? 'Regenerating…' : 'Regenerate' }}</button>
          </div>
        </div>

        <!-- editor notes -->
        <div class="erv-notes">
          <label class="ei-mono">Editor notes</label>
          <textarea class="ei-mono" rows="2" [(ngModel)]="notesDraft" name="notesDraft"
                    placeholder="Reviewer notes (saved without changing status)…"></textarea>
          <button class="erv-btn ei-mono" (click)="saveNotes()">Save notes</button>
        </div>

        <div class="erv-empty ei-mono" *ngIf="loadingDetail && !article">Loading article…</div>

        <!-- panel tabs -->
        <nav class="erv-tabs ei-mono" *ngIf="article">
          <button class="erv-tab" [class.on]="activePanel==='article'" (click)="activePanel='article'">Article</button>
          <button class="erv-tab" [class.on]="activePanel==='evidence'" (click)="activePanel='evidence'">Evidence &amp; references</button>
          <button class="erv-tab" [class.on]="activePanel==='media'" (click)="activePanel='media'">Media &amp; rights</button>
        </nav>

        <ng-container *ngIf="article as a">
          <!-- NOT READY -->
          <div class="erv-callout bad" *ngIf="a.status === 'not_ready'">
            <b>NOT READY FOR ARTICLE</b>
            <ul><li *ngFor="let r of a.reasons">{{ r }}</li></ul>
          </div>

          <ng-container *ngIf="a.status === 'generated' && a.article as art">
            <!-- ARTICLE PANEL -->
            <div *ngIf="activePanel==='article'">
              <div class="erv-card">
                <div class="erv-seo ei-mono">
                  <div><b>SEO title:</b> {{ art.seoTitle }}</div>
                  <div><b>Meta title:</b> {{ art.metaTitle }}</div>
                  <div><b>Meta description:</b> {{ art.metaDescription }}</div>
                  <div><b>URL slug:</b> {{ art.urlSlug }}</div>
                  <div><b>Primary keyword:</b> {{ art.primaryKeyword }}</div>
                  <div><b>Confidence:</b> {{ art.confidenceStatement }}</div>
                </div>
              </div>
              <div class="erv-card">
                <div class="erv-cardh ei-mono">Markdown preview</div>
                <pre class="erv-markdown">{{ art.markdown }}</pre>
              </div>
            </div>

            <!-- EVIDENCE PANEL -->
            <div *ngIf="activePanel==='evidence'">
              <div class="erv-card" *ngIf="dossier as d">
                <div class="erv-cardh ei-mono">Claims (dossier)</div>
                <div class="erv-claim" *ngFor="let c of d.claims">
                  <div>{{ c.text }}</div>
                  <div class="erv-sub ei-mono">confidence {{ c.confidence }} · sources [{{ (c.sourceIds || []).join(', ') }}]</div>
                </div>
                <div class="erv-cardh ei-mono" style="margin-top:14px;">Sources</div>
                <div class="erv-src ei-mono" *ngFor="let sr of d.sources">
                  <span class="erv-pill" [ngClass]="statusClass('in_review')">T{{ sr.tier }}</span>
                  {{ sr.title }} <a *ngIf="sr.url" [href]="sr.url" target="_blank" rel="noopener">↗</a>
                </div>
              </div>
              <div class="erv-card">
                <div class="erv-cardh ei-mono">Article references</div>
                <ol><li class="ei-mono" *ngFor="let r of art.sourceReferences">{{ r }}</li></ol>
              </div>
              <div class="erv-card" *ngIf="manualReferences.length">
                <div class="erv-cardh ei-mono">Manually imported references ({{ manualReferences.length }})</div>
                <div class="erv-src ei-mono" *ngFor="let m of manualReferences">
                  <span class="erv-pill" [ngClass]="rightsClass(m.licenceStatus)">{{ rights5(m.licenceStatus) }}</span>
                  {{ m.caption || m.url }}
                  <a *ngIf="m.url" [href]="m.url" target="_blank" rel="noopener">↗</a>
                </div>
              </div>
            </div>

            <!-- MEDIA PANEL -->
            <div *ngIf="activePanel==='media'">
              <div style="margin-bottom:16px;">
                <pla-editorial-import-panel [registration]="selected.registration" (imported)="reloadDossier()"></pla-editorial-import-panel>
              </div>
              <div class="erv-card">
                <div class="erv-cardh ei-mono">Media &amp; rights — reference only, never rehosted ({{ activeMedia.length }})</div>
                <div class="erv-empty ei-mono" *ngIf="!activeMedia.length">No active media for this registration.</div>
                <div class="erv-media" *ngFor="let m of activeMedia">
                  <div class="erv-mtop">
                    <span class="erv-pill ei-mono" [ngClass]="rightsClass(m.licenceStatus)">{{ rights5(m.licenceStatus) }}</span>
                    <span class="erv-pill ei-mono muted">{{ m.mediaType }}</span>
                    <span class="erv-pill ei-mono" [ngClass]="statusClass(m.status)">{{ statusLabel(m.status) }}</span>
                  </div>
                  <!-- Remote thumbnail only — never downloaded/rehosted; placeholder if none. -->
                  <div class="erv-mthumb" *ngIf="thumbFor(m) && !thumbBroken(m); else noThumb">
                    <img [src]="thumbFor(m)" alt="reference thumbnail" loading="lazy"
                         referrerpolicy="no-referrer" (error)="onThumbError(m)" />
                  </div>
                  <ng-template #noThumb>
                    <div class="erv-mthumb erv-mthumb-empty ei-mono">No thumbnail available</div>
                  </ng-template>
                  <div class="erv-mcap">{{ m.caption || m.url }}</div>
                  <div class="erv-sub ei-mono">
                    <a *ngIf="m.url || m.embedUrl" [href]="m.url || m.embedUrl" target="_blank" rel="noopener">Open source ↗</a>
                    <a *ngIf="thumbFor(m)" [href]="thumbFor(m)" target="_blank" rel="noopener">Open image ↗</a>
                  </div>
                  <div class="erv-mbtns ei-mono">
                    <button class="erv-btn ok" [disabled]="isMediaPending(m)" (click)="mediaActionRun(m,'approve')">Approve</button>
                    <button class="erv-btn bad" [disabled]="isMediaPending(m)" (click)="mediaActionRun(m,'reject')">Reject</button>
                    <button class="erv-btn warn" [disabled]="isMediaPending(m)" (click)="mediaActionRun(m,'flag')">Flag</button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </section>
  </div>

  <div class="erv-toast ei-mono" *ngIf="toastMessage">{{ toastMessage }}</div>
</div>

<ng-template #gateTpl>
  <div class="erv-empty ei-mono" style="padding:60px;">Verifying admin access…</div>
</ng-template>
